import InventoryTable from "./InventoryTable";
export default InventoryTable;
